export default __webpack_public_path__ + "images/c55f99382ac372e9b95ac3ba6f6c1821-2_4K_1920x544.jpg";